import Vue from "vue";

import Multiselect from "vue-multiselect";
Vue.component("multiselect", Multiselect);
import Vuebar from "vuebar";
import VueModalTor from "vue-modaltor";
import Ripple from "vue-ripple-directive";

import VuePersianDatetimePicker from "vue-persian-datetime-picker";

import StarRating from "vue-star-rating";

import "bootstrap-vue/dist/bootstrap-vue.css";

import {
  VBTooltip,
  VBToggle ,
  VBPopover ,
  BCollapse,
  BTabs,
  BTab,
  BCard,
  BProgress,
  BTable,
  BPagination,
  CollapsePlugin 
} from "bootstrap-vue";
// import bTabs from "bootstrap-vue";
import { ContentLoader } from "vue-content-loader";
import VueProgressiveImage from "vue-progressive-image";
import VueAwesomeSwiper from "vue-awesome-swiper";
import moment from "moment-jalaali";
// require styles
import "swiper/dist/css/swiper.css";
import "../../static/css/vue-multiselect.min.css";

Vue.use(CollapsePlugin )
// import VueQuillEditor from "vue-quill-editor";
import VueQuillEditor, { Quill } from 'vue-quill-editor'
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)
// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.use(VueQuillEditor, {
  modules: {
    toolbar: toolbarOptions
  },
  placeholder: "متن ... "
});


import Editor from '@tinymce/tinymce-vue';
Vue.component('tinymce-editor',Editor)

import ToggleButton from "vue-js-toggle-button";
Vue.component("date-picker", VuePersianDatetimePicker);

Vue.use(VueModalTor);
Vue.directive("ripple", Ripple);
Vue.use(Vuebar);

import VeeValidate from "vee-validate";
//import for locale
import { Validator } from "vee-validate";
import messagesFA from "vee-validate/dist/locale/fa";
//config for locale
//localize fa
Validator.localize("fa", messagesFA);

Vue.use(VeeValidate, {
  errorBagName: "errors", // change if property conflicts
  fieldsBagName: "filded",
  delay: 0,
  locale: "fa",
  dictionary: null,
  strict: true,
  classes: false,
  events: "input|blur",
  inject: true,
  validity: false,
  aria: true
});
Vue.component(
  "controller-curose",
  require("~/components/controller-curose.vue").default
);
Vue.component("app-loading", require("~/components/loading.vue").default);
Vue.component("page-number", require("~/components/pageNumber.vue").default);
// import contactForm from "cp/contact-form.vue"
Vue.component("contact-form", require("~/components/contact-form.vue").default);
Vue.component("star-rating", StarRating);
Vue.directive('b-popover', VBPopover)
Vue.directive("b-tooltip", VBTooltip);
Vue.directive("b-toggle", VBToggle);
Vue.component('b-collapse',BCollapse);
Vue.component('b-tabs',BTabs);
Vue.component('b-tab',BTab);
Vue.component('b-card',BCard);
Vue.component('b-progress',BProgress);
Vue.use(ContentLoader);
Vue.component("content-loader", ContentLoader);
Vue.use(VueProgressiveImage);
Vue.use(ToggleButton);
Vue.component('b-table',BTable);
Vue.component('b-pagination',BPagination);
// , /* { default global options } */
Vue.use(VueAwesomeSwiper);
var toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  [{ align: [] }],
  [{ direction: "rtl" }],
  ["link", "video", "code-block"],
  [{ list: "ordered" }, { list: "bullet" }]
];



// WEBPACK FOOTER //
// ./src/plugins/global.js